import { Injectable } from '@angular/core';
import * as uuid from 'uuid';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { AlertController } from '@ionic/angular';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  referenceNumber: string;
  channelId: string;
  username: string;
  userAgent: string;
  terminalSerialNumber: string; // Add this line
  signature: string; // Add this line

  constructor(
    public alertCtrl: AlertController,
    private translate: TranslateService,
    private storage: StorageService,
  ) {
    this.referenceNumber = uuid.v1();
    this.channelId = environment.channel.id;
    this.terminalSerialNumber = ""; // Initialize or assign appropriately
    this.signature = ""; // Initialize or assign appropriately
    // this.storage.get('user').then(userData => {
    //   if (userData) {
    //     this.username = userData.email;
    //   }
    // });
    // this.userAgent = navigator.userAgent;
  }

  generateUUID() {
    return uuid.v1();
  }

  // Display alert message when user input wrongly or doesnt input required fields.
  async getFormValidity(event: boolean) {
    if (event === false) {
      const alert = await this.alertCtrl.create({
        header: this.translate.instant('formValidity.header'),
        message: this.translate.instant('formValidity.message'),
        buttons: [this.translate.instant('formValidity.button')]
      });
      await alert.present();
    }
  }

}
